export default {
  credentialsContainer: {
    display: 'flex',
    gap: 16,
    marginTop: 16,
    marginBottom: 16,
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'right',
    flex: 1,
    marginTop: 16,
    gap: 16,
  },
  port: {
    maxWidth: 100,
    padding: 8,
    boxSizing: 'border-box',
  },
  inputContainer: {
    flex: 1,
    width: '100%',
    maxWidth: '100%',
    padding: 8,
    boxSizing: 'border-box',
  },
  header: {
    marginBottom: 8,
    fontWeight: 'bold',
  },
  confTitle: {
    fontSize: 12,
    fontWeight: 'bold',
    color: '#3d3d3d',
  },
  validateSFTPWithoutErrors: {
    display: 'flex',
    gap: 16,
    marginTop: 16,
    marginBottom: 16,
    color: 'green',
  },
  validateSFTPWithErrors: {
    display: 'flex',
    gap: 16,
    marginTop: 16,
    marginBottom: 16,
    color: 'red',
  },
};
